
import { defineAsyncComponent, defineComponent } from "vue";
import Call from "../components/landingpage/Call.vue";
import Introduction from "../components/landingpage/Introduction.vue";
import Mission from "../components/landingpage/Mission.vue";
import Footer from "../components/application/moldure/Footer.vue";
import ResetPassword from "../components/landingpage/ResetPassword.vue";
import { useRouter } from "vue-router";
import FirstLogin from "../components/landingpage/FirstLogin.vue";
import { enableBodyOverflow } from "../components/mixins";
import ModalTerm from "../components/landingpage/ModalTerm.vue";
import Faq from "../components/landingpage/Faq.vue";

export default defineComponent({
  components: {
    ModalTerm,
    Call,
    Introduction,
    Mission,
    HomeFooter: Footer,
    ResetPassword,
    FirstLogin,
    Faq,
  },

  setup() {
    /** Instance of a router. */
    const router = useRouter();

    /** Closes the currently open modal by redirecting user to the home page. */
    const closeModal = async () => {
      await router.push({ name: "home" });
      enableBodyOverflow();
    };

    const SupportersComponent = defineAsyncComponent(() => {
      if (process.env.VUE_APP_THEME === "construcolor") {
        return import("../components/landingpage/supporters/Construcolor.vue");
      }
      return import("../components/landingpage/supporters/Lince.vue");
    });

    return {
      closeModal,
      SupportersComponent,
    };
  },
});
